"use script";

// All specific constant for the build
angular.module("customer")

.constant("APP_OWNER", "wegotrade")
.constant("CUSTOMER_TYPE_REGISTRATION", "business"); // see /core/customer-model/customer.constant.js




//////////////////
// WEBPACK FOOTER
// ./customer/app-build-constant/wegotrade.customizations.js
// module id = 715
// module chunks = 0